<app-header [hideBackButton]="false"></app-header>
<ion-content>
  <ion-list
    *ngIf="(moreVM$ | async) as moreVM"
    data-cy="more-actions-list"
    class="list-more-mobile"
    lines="none"
  >
    <div class="group">
      <ion-item
        class="btm-line"
        data-cy="more-actions-list-item-browse-categories"
        (click)="routeToBrowse()"
      >
        <ion-label *ngIf="!isGuestUserAndSearchBrowseFeatureFlag"
          >{{ 'i18n.moxe-links.browseCategories' | translate }}</ion-label
        >
        <ion-label *ngIf="isGuestUserAndSearchBrowseFeatureFlag"
          >{{ 'i18n.moxe-links.guestBrowseProducts' | translate }}</ion-label
        >
      </ion-item>
      <ion-item
        *ngIf="!moreVM?.isMasterListRestrictedCustomer"
        [disabled]="isGuestUser"
        class="btm-line"
        data-cy="more-actions-list-item-deals"
        (click)="!isGuestUser && routeTo([PATHS.DEALS])"
      >
        <ion-label>{{ 'i18n.deals.dealsMenuTitle' | translate }}</ion-label>
      </ion-item>
      <ion-item
        *ngIf="!moreVM?.isMasterListRestrictedCustomer && (isDealsAvailable || isGuestUser)"
        [disabled]="isGuestUser"
        class="btm-line"
        data-cy="more-actions-list-item-available-deals"
        (click)="!isGuestUser && routeTo([PATHS.DEALS, PATHS.ALL_DEALS])"
      >
        <ion-label>{{ 'i18n.deals.allDeals' | translate }}</ion-label>
      </ion-item>

      <ion-item
        [disabled]="isGuestUser"
        class="btm-line"
        data-cy="more-actions-list-item-while-supplies-last"
        (click)="!isGuestUser && routeToSuppliesLast()"
      >
        <ion-label>{{ 'i18n.moxe-links.supplies' | translate }}</ion-label>
      </ion-item>

      <ion-item
        [hidden]="!moreVM?.betterBuysFlag"
        class="btm-line"
        data-cy="more-actions-better-buys"
        (click)="routeTo([PATHS.BETTER_BUYS])"
      >
        <ion-label>{{'i18n.moxe-links.betterBuys' | translate}}</ion-label>
      </ion-item>

      <ion-item
        *ngIf="!moreVM?.isMasterListRestrictedCustomer"
        class="btm-line"
        data-cy="more-actions-list-item-scoop"
        (click)="routeToScoop()"
      >
        <ion-label>{{ 'i18n.moxe-links.scoop' | translate }}</ion-label>
      </ion-item>

      <ion-item
        *ngIf="showEquipmentSupplies"
        class="btm-line"
        data-cy="more-actions-list-item-equipmentAndSupplies"
        (click)="routeToEquipmentAndSupplies()"
      >
        <ion-label
          >{{ 'i18n.moxe-links.equipmentAndSupplies' | translate }}</ion-label
        >
      </ion-item>

      <ion-item
        class="btm-line"
        data-cy="more-actions-list-item-serveGood"
        (click)="routeToExternalWeb(serveGoodLink)"
      >
        <ion-label>{{ 'i18n.moxe-links.serveGood' | translate }}</ion-label>
        <ion-icon
          src="assets/icon/external-link-green.svg"
          class="external-link"
          slot="end"
        ></ion-icon>
      </ion-item>

      <ion-item
        class="btm-line"
        data-cy="more-actions-list-item-serveYou"
        (click)="routeToServeYou()"
      >
        <ion-label>{{ 'i18n.moxe-links.serveYou' | translate }}</ion-label>
      </ion-item>

      <ion-item
        *ngIf="moreVM?.showRecipes"
        [disabled]="isGuestUser"
        class="btm-line"
        data-cy="more-actions-list-item-recipes"
        (click)="!isGuestUser && routeToRecipes()"
      >
        <ion-label>{{ 'i18n.moxe-links.healthCare' | translate }}</ion-label>
        <ion-icon
          src="assets/icon/external-link-green.svg"
          class="external-link"
          slot="end"
        ></ion-icon>
      </ion-item>
      <ion-item
        *ngIf="moreVM?.showSellerShowcaseProducts"
        class="btm-line"
        data-cy="more-actions-list-item-sellerShowcaseProducts"
        (click)="routeToSellerShowcase()"
      >
        <ion-label
          >{{ 'i18n.moxe-links.sellerShowcaseProducts' | translate }}</ion-label
        >
      </ion-item>
    </div>
  </ion-list>
</ion-content>
<app-footer></app-footer>
